import { render, staticRenderFns } from "./CharactersSelection.vue?vue&type=template&id=3d18ace2&scoped=true&"
import script from "./CharactersSelection.vue?vue&type=script&lang=js&"
export * from "./CharactersSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18ace2",
  null
  
)

export default component.exports